import './Customer.scss';
import Component from './Customer.js';
export default Component;
